import { render } from "./ImagesGestionPage.vue?vue&type=template&id=7b48d8ee"
import script from "./ImagesGestionPage.vue?vue&type=script&lang=js"
export * from "./ImagesGestionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__